module.exports = __webpack_public_path__ + "static/media/red_word_count.9ee2cb3c.svg";